import { ChangeEvent, useEffect, useRef, useState } from 'react'
import { RefCallBack } from 'react-hook-form'

import { Input, InputProps } from '@/components/ui/input'
import { cn } from '@/lib/utils'

type ViverseInputProps = InputProps & {
  ref?: React.RefObject<HTMLInputElement | null> | RefCallBack
  containerClassName?: string
}

function ViverseInput({
  className,
  onChange,
  maxLength,
  ref,
  containerClassName,
  ...props
}: ViverseInputProps) {
  const [valueLength, setValueLengh] = useState(0)
  const defaultValue = useRef(typeof props.value === 'string' ? props.value : '')

  useEffect(() => {
    if (defaultValue.current) {
      setValueLengh(defaultValue.current.length)
    }
  }, [])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e)
    setValueLengh(e.target.value.length)
  }

  return (
    <div className="box-border flex w-full items-center">
      <div
        className={cn(
          'border-vive-primary-70 bg-vive-popup focus-within:border-vive-border-focus hover:border-vive-brand-50 flex flex-1 items-center rounded-md border-2 transition-all duration-300',
          containerClassName,
        )}
      >
        <Input
          className={cn(
            'bg-vive-popup min-h-12 rounded-sm border-none tracking-[0.2px] text-white',
            className,
          )}
          onChange={handleChange}
          maxLength={maxLength}
          ref={ref}
          {...props}
        />
        {maxLength && (
          <div className="h-full w-max px-3 text-nowrap">
            <span className="caption text-vive-primary-40">
              {valueLength} / {maxLength}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default ViverseInput
